import {
    GET_KPI_DASHBOARDS_METADATA_REQUEST, GET_KPI_DASHBOARDS_METADATA_SUCCESS, GET_KPI_DASHBOARDS_METADATA_FAIL,
    GET_KPI_SOURCES_METADATA_REQUEST, GET_KPI_SOURCES_METADATA_SUCCESS, GET_KPI_SOURCES_METADATA_FAIL,
    GET_KPI_FIELDS_METADATA_REQUEST, GET_KPI_FIELDS_METADATA_SUCCESS, GET_KPI_FIELDS_METADATA_FAIL,
    GET_KPI_WIDGET_PREVIEW_REQUEST, GET_KPI_WIDGET_PREVIEW_SUCCESS, GET_KPI_WIDGET_PREVIEW_FAIL,
    GET_KPI_DASHBOARD_PREVIEW_REQUEST, GET_KPI_DASHBOARD_PREVIEW_SUCCESS, GET_KPI_DASHBOARD_PREVIEW_FAIL,
    CREATE_KPI_CONFIGURATION_REQUEST, CREATE_KPI_CONFIGURATION_SUCCESS, CREATE_KPI_CONFIGURATION_FAIL,
    UPDATE_KPI_CONFIGURATION_REQUEST, UPDATE_KPI_CONFIGURATION_SUCCESS, UPDATE_KPI_CONFIGURATION_FAIL,
    DELETE_KPI_CONFIGURATION_REQUEST, DELETE_KPI_CONFIGURATION_SUCCESS, DELETE_KPI_CONFIGURATION_FAIL,
    GET_ALL_KPI_CONFIGURATIONS_REQUEST, GET_ALL_KPI_CONFIGURATIONS_SUCCESS, GET_ALL_KPI_CONFIGURATIONS_FAIL,
    GET_KPI_DASHBOARD_DATA_REQUEST, GET_KPI_DASHBOARD_DATA_SUCCESS, GET_KPI_DASHBOARD_DATA_FAIL
} from '../actions/kpiActions';

const safeArray = (value) => (Array.isArray(value) ? value : []);

const initialState = {
    metadata: {
        dashboards: [],
        sources: [],
        fields: []
    },
    preview: {
        widgetPreview: null,
        dashboardPreview: { widgets: [] }
    },
    configurations: {
        list: [],
        current: null
    },
    dashboardData: {
        widgets: []
    },
    loading: {
        metadataLoading: false,
        previewLoading: false,
        saveLoading: false,
        dashboardLoading: false
    },
    error: {
        metadataError: null,
        previewError: null,
        saveError: null,
        dashboardError: null
    }
};

function kpiReducer(state = initialState, action) {
    switch (action.type) {
        case GET_KPI_DASHBOARDS_METADATA_REQUEST:
        case GET_KPI_SOURCES_METADATA_REQUEST:
        case GET_KPI_FIELDS_METADATA_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, metadataLoading: true },
                error: { ...state.error, metadataError: null }
            };

        case GET_KPI_DASHBOARDS_METADATA_SUCCESS:
            return {
                ...state,
                metadata: { ...state.metadata, dashboards: safeArray(action.payload) },
                loading: { ...state.loading, metadataLoading: false }
            };
        case GET_KPI_SOURCES_METADATA_SUCCESS:
            return {
                ...state,
                metadata: { ...state.metadata, sources: safeArray(action.payload) },
                loading: { ...state.loading, metadataLoading: false }
            };
        case GET_KPI_FIELDS_METADATA_SUCCESS:
            return {
                ...state,
                metadata: { ...state.metadata, fields: safeArray(action.payload) },
                loading: { ...state.loading, metadataLoading: false }
            };

        case GET_KPI_DASHBOARDS_METADATA_FAIL:
        case GET_KPI_SOURCES_METADATA_FAIL:
        case GET_KPI_FIELDS_METADATA_FAIL:
            return {
                ...state,
                loading: { ...state.loading, metadataLoading: false },
                error: { ...state.error, metadataError: action.error }
            };

        case GET_KPI_WIDGET_PREVIEW_REQUEST:
        case GET_KPI_DASHBOARD_PREVIEW_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, previewLoading: true },
                error: { ...state.error, previewError: null }
            };

        case GET_KPI_WIDGET_PREVIEW_SUCCESS:
            return {
                ...state,
                preview: {
                    ...state.preview,
                    widgetPreview: action.payload
                        ? { ...action.payload, isSimulated: action.payload.isSimulated ?? true }
                        : null
                },
                loading: { ...state.loading, previewLoading: false }
            };
        case GET_KPI_DASHBOARD_PREVIEW_SUCCESS:
            return {
                ...state,
                preview: {
                    ...state.preview,
                    dashboardPreview: {
                        widgets: safeArray(action.payload?.widgets)
                    }
                },
                loading: { ...state.loading, previewLoading: false }
            };

        case GET_KPI_WIDGET_PREVIEW_FAIL:
        case GET_KPI_DASHBOARD_PREVIEW_FAIL:
            return {
                ...state,
                loading: { ...state.loading, previewLoading: false },
                error: { ...state.error, previewError: action.error }
            };

        case CREATE_KPI_CONFIGURATION_REQUEST:
        case UPDATE_KPI_CONFIGURATION_REQUEST:
        case DELETE_KPI_CONFIGURATION_REQUEST:
        case GET_ALL_KPI_CONFIGURATIONS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, saveLoading: true },
                error: { ...state.error, saveError: null }
            };

        case CREATE_KPI_CONFIGURATION_SUCCESS:
            return {
                ...state,
                configurations: {
                    ...state.configurations,
                    list: [...safeArray(state.configurations.list), action.payload]
                },
                loading: { ...state.loading, saveLoading: false }
            };
        case UPDATE_KPI_CONFIGURATION_SUCCESS:
            return {
                ...state,
                configurations: {
                    ...state.configurations,
                    list: safeArray(state.configurations.list).map((item) => (item.id === action.payload.id ? action.payload : item))
                },
                loading: { ...state.loading, saveLoading: false }
            };
        case DELETE_KPI_CONFIGURATION_SUCCESS:
            return {
                ...state,
                configurations: {
                    ...state.configurations,
                    list: safeArray(state.configurations.list).filter((item) => item.id !== action.payload)
                },
                loading: { ...state.loading, saveLoading: false }
            };
        case GET_ALL_KPI_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                configurations: { ...state.configurations, list: safeArray(action.payload) },
                loading: { ...state.loading, saveLoading: false }
            };

        case CREATE_KPI_CONFIGURATION_FAIL:
        case UPDATE_KPI_CONFIGURATION_FAIL:
        case DELETE_KPI_CONFIGURATION_FAIL:
        case GET_ALL_KPI_CONFIGURATIONS_FAIL:
            return {
                ...state,
                loading: { ...state.loading, saveLoading: false },
                error: { ...state.error, saveError: action.error }
            };

        case GET_KPI_DASHBOARD_DATA_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, dashboardLoading: true },
                error: { ...state.error, dashboardError: null }
            };
        case GET_KPI_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                dashboardData: { ...state.dashboardData, widgets: safeArray(action.payload?.widgets) },
                loading: { ...state.loading, dashboardLoading: false }
            };
        case GET_KPI_DASHBOARD_DATA_FAIL:
            return {
                ...state,
                dashboardData: { ...state.dashboardData, widgets: [] },
                loading: { ...state.loading, dashboardLoading: false },
                error: { ...state.error, dashboardError: action.error }
            };

        default:
            return state;
    }
}

export default kpiReducer;
